import React from 'react';
import CameraConfigTab from './CameraConfigTab';

interface CameraDiscoveryTabProps {
  isDemoUser?: boolean;
}

const CameraDiscoveryTab: React.FC<CameraDiscoveryTabProps> = ({ isDemoUser = false }) => (
  <CameraConfigTab isDemoUser={isDemoUser} />
);

export default CameraDiscoveryTab;
